define(['jquery', 'accounting', 'common'], function ($, Accounting, ERVCommon) {

		var PriceHelper = function() {
			var self = this;
			self.$ervBody = $('#erv-body');
			self.common = new ERVCommon();

			self.getExcessInput = function ($container) {

				if ($container === null || typeof ($container) === 'undefined') {
					return null;
				}

				//is it in $container?
				var $excessContainer = $container.find('.excess-container');

				//check from top level product box
				if ($excessContainer.length === 0) {
					$excessContainer = $container.parents('.product.booking').find('.excess-container');
				}

				var $excessInput = $excessContainer.find('input[type="checkbox"]:not(:disabled)');

				if ($excessInput.length === 0)
				{
					return null;
				}

				return $excessInput;
			};
		};

		PriceHelper.prototype.AddTaxAndDiscount = function ($currentItem, $trigger, price) {
			var currentDiscount = Number($trigger.parents('[data-discount-pct]').attr('data-discount-pct')),
				currentTax = Number($currentItem.data('tax-pct')) * 0.01,
				$discountRate = $currentItem.find('[data-js="discount-rate"]');

			if (isNaN(currentDiscount)) {
				currentDiscount = Number($trigger.parents('[data-view="step2"]').find('[data-discount-pct]:not(.hide)').attr('data-discount-pct'));
			}

			currentDiscount = currentDiscount * 0.01;

			if (currentDiscount > 0) {
				price = price - (price * currentDiscount);
				$discountRate.parent().removeClass('hide');

				if ($discountRate.length > 0) {
					var roundedDiscount = Math.round(Number($trigger.parents('[data-discount-pct]').attr('data-discount-pct')));
					if (!isNaN(roundedDiscount)) {
						$discountRate.text(roundedDiscount);
					}
				}
			} else {
				$discountRate.parent().addClass('hide');
			}

			if (currentTax > 0) {
				price = price + (price * currentTax);
			}

			return price;
		};

		PriceHelper.prototype.updatePrice = function ($currentItem, $trigger, price, isAdded, calculateTaxAndDiscount) {
			var self = this;

			var $priceContainer = $currentItem.find('[data-oldprice]'),
				$currentPriceContainer = $priceContainer.find('[data-currentprice]'),
				oldPrice = $priceContainer.data('oldprice'),
				changedPrice;

			if (isAdded) {
				changedPrice = Number(oldPrice) + Number(price);
			} else {
				changedPrice = Number(oldPrice) - Number(price);
			}

			$priceContainer.data('oldprice', changedPrice);
			$currentPriceContainer.data('currentprice', changedPrice);

			if (calculateTaxAndDiscount) {
				changedPrice = self.AddTaxAndDiscount($currentItem, $trigger, changedPrice);
			}

			$currentPriceContainer.text(self.formatPrice(changedPrice));
		};

		PriceHelper.prototype.updateTotalPrice = function ($currentItem, $trigger, price) {
			var self = this;

			var $priceContainer = $currentItem.find('[data-oldprice]'),
				$currentPriceContainer = $priceContainer.find('[data-currentprice]'),
				changedPrice = price;

			$priceContainer.data('oldprice', changedPrice);
			$currentPriceContainer.data('currentprice', changedPrice);

			changedPrice = self.AddTaxAndDiscount($currentItem, $trigger, changedPrice);

			$currentPriceContainer.text(self.formatPrice(changedPrice));
		};

		PriceHelper.prototype.updatePriceCancellation = function ($currentItem, $trigger, price, previousPrice) {
			var self = this;
			self.updatePrice($currentItem, $trigger, previousPrice, false);
			self.updatePrice($currentItem, $trigger, price, true, true);
		};

		PriceHelper.prototype.hasExcess = function ($container) {
			var self = this,
				$excessInput = self.getExcessInput($container);

			if ($excessInput === null || $excessInput == undefined) {
				return false;
			}

			return $excessInput.is(':checked');
		};

		PriceHelper.prototype.hasPresetExcess = function ($container) {
			var self = this,
				$excessInput = self.getExcessInput($container);

			if ($excessInput === null || $excessInput == undefined) {
				return false;
			}

			return $excessInput.data('presetchecked').toString() === 'true';
		};

		PriceHelper.prototype.getIncludedExcessPrice = function ($container) {
			var self = this,
				$excessInput = self.getExcessInput($container);

			if ($excessInput === null || $excessInput === undefined) {
				return 0;
			}

			return Number($excessInput.data('includedexcessprice'));
		};

		PriceHelper.prototype.setExcess = function (hasExcess, hasPresetExcess, price, adjustment) {
			if (hasExcess && !hasPresetExcess) {
				price -= adjustment;
			} else if (!hasExcess && hasPresetExcess) {
				price += adjustment;
			}

			return price;
		};

		PriceHelper.prototype.calculateTotalPriceInContainer = function ($container) {
			var price = 0,
				self = this,
				hasExcess = self.hasExcess($container),
				hasPresetExcess = self.hasPresetExcess($container),
				includedExcessPrice = self.getIncludedExcessPrice($container);

			var $inputsToCalculate = $container.find('input[type="checkbox"]').filter(function() {
				return !this.disabled && this.checked;
			});

			var $optionsToCalculate = $container.find('select option').filter(function () {
				return !$(this).parent()[0].disabled && this.selected;
			});

			$inputsToCalculate.each(function () {
				var $input = $(this),
					inputPrice = $input.data('price'),
					inputExcessPrice = $input.data('addon-excess-price');

				if (inputPrice != undefined) {
					price += inputPrice;
				}

				if (inputExcessPrice != undefined) {
					price = self.setExcess(hasExcess, hasPresetExcess, price, inputExcessPrice);
				}
			});


			$optionsToCalculate.each(function () {
				price += $(this).data('price');
			});

			if (includedExcessPrice !== 0) {
				price = self.setExcess(hasExcess, hasPresetExcess, price, includedExcessPrice);
			}
			
			return Number(price);
		}

		PriceHelper.prototype.calculateAddOnExcessTotalPriceInContainer = function ($container) {
			var self = this,
				price = 0,
				includedExcessPrice = self.getIncludedExcessPrice($container);

			var $inputsToCalculate = $container.find('input[type="checkbox"]').filter(function () {
				return !this.disabled && this.checked;
			});

			$inputsToCalculate.each(function () {
				var $input = $(this),
					inputExcessPrice = $input.data('addon-excess-price');

				if (inputExcessPrice !== undefined) {
					price += inputExcessPrice;
				}
			});

			if (includedExcessPrice !== 0) {
				price += includedExcessPrice;
			}

			return Number(price);
		}

		PriceHelper.prototype.formatPrice = function (price, withDecimals) {
			var presentedPrice = parseFloat((price * 100) / 100),
				self = this,
				orglang = $('html').data('orglang');

			if (typeof (withDecimals) === 'undefined') {
				withDecimals = true;
			}

			presentedPrice = Math.round10(presentedPrice, -2);

			if (orglang === 'da') {
				return Accounting.formatNumber(presentedPrice, !withDecimals ? 0 : 2, ".", ",");
			}

			if (orglang === 'en' || orglang === 'fi') {
				if (self.common.framework.checks.isDk()) {
					return Accounting.formatNumber(presentedPrice, withDecimals ? 2 : 0, ".", ",");
				}
			}

			return Accounting.formatNumber(presentedPrice, 0, " ", ",");
		};

		return PriceHelper;
});